import { SelectedFeaturesFragment } from '~/graphql/__generated__/graphql';

export function mapSelection(response: SelectedFeaturesFragment, modelCode: string): Set<string> {
	const selection = new Set<string>();
	selection.add(modelCode ?? '');

	for (const item of response.features.data) {
		selection.add(item.pr7);
	}

	for (const item of response.packagesDetails.data ?? []) {
		selection.add(item.pr7);
	}

	for (const model of response.models?.data ?? []) {
		if (model && model.status?.selected) {
			selection.add(model.trimlineId ?? '');
		}
	}

	return selection;
}
